import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface User {
  id: string;
  telegramId: string;
  telegramUsername?: string;
  firstName: string;
  lastName?: string;
  photoUrl?: string;
}

interface AuthState {
  user: User | null;
  token: string | null;
  isAuthenticated: boolean;
  setAuth: (user: User, token: string) => void;
  logout: () => void;
}

/**
 * Telegram login widget photo URLs (t.me/i/userpic/...) are temporary and
 * frequently return 404. Strip them so we always fall back to initials.
 */
function sanitizePhotoUrl(url?: string): string | undefined {
  if (!url) return undefined;
  if (url.includes('t.me/i/userpic')) return undefined;
  return url;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      token: null,
      isAuthenticated: false,
      setAuth: (user, token) =>
        set({
          user: { ...user, photoUrl: sanitizePhotoUrl(user.photoUrl) },
          token,
          isAuthenticated: true,
        }),
      logout: () =>
        set({ user: null, token: null, isAuthenticated: false }),
    }),
    {
      name: 'haive-auth',
    }
  )
);
